module.exports = __webpack_public_path__ + "img/scene2-2.9fbd82c7.png";